export default "__VITE_ASSET__Dk4f1d2z__"